module.exports = __webpack_public_path__ + "static/trident_of_fish_command-da8c85ecd056f816f383a9f6a9a2e49f.jpeg";